import { useMutation } from '@apollo/client/react'
import { Box, HStack, Link, Field } from '@chakra-ui/react'
import { Switch } from '@src/components/chakra-ui/switch'
import { Tooltip } from '@src/components/chakra-ui/tooltip'
import { MatchEmailsExplainerModal } from '@src/components/sco/Matching/UserSearchForm'
import { ScoUserSearch } from '@src/graphql-types'
import { gql } from '@src/lib/gql'
import React from 'react'

export const UserSearchEmailToggle = (props: { hideLabel?: boolean; userSearch: ScoUserSearch }) => {
  const [matchEmailsModelIsOpen, setMatchEmailsModalIsOpen] = React.useState(false)

  const [upsertUserSearch, upsertUserSearchMutation] = useMutation(gql`
    mutation ($input: UpsertUserSearchInput!) {
      upsertUserSearch(input: $input) {
        userSearch {
          id
          isMatchEmailEnabled
        }
      }
    }
  `)

  const [isMatchEmailEnabled, setIsMatchEmailEnabled] = React.useState(props.userSearch.isMatchEmailEnabled)

  return (
    <Field.Root>
      <HStack align={'center'} justify={'space-between'} width={'full'}>
        {!props.hideLabel && (
          <Box flexGrow={1}>
            <Field.Label color={'colorPalette.fg'} paddingY={0} textStyle={'xs'}>
              Email Me Updates
              {' • '}
              <Tooltip content={"We'll notify you about new matches."} showArrow={true}>
                <Link
                  fontSize={'xs'}
                  fontWeight={'normal'}
                  opacity={0.67}
                  variant={'underline'}
                  onClick={ev => {
                    ev.preventDefault()
                    ev.stopPropagation()
                    setMatchEmailsModalIsOpen(true)
                  }}
                >
                  Learn More
                </Link>
              </Tooltip>
            </Field.Label>
          </Box>
        )}

        <Switch
          checked={isMatchEmailEnabled}
          colorPalette={'teal'}
          size={'md'}
          value={1}
          onChange={() => {
            const newValue = !isMatchEmailEnabled
            setIsMatchEmailEnabled(newValue)
            upsertUserSearch({
              variables: {
                input: {
                  userSearchId: props.userSearch.userSearchId,
                  isMatchEmailEnabled: newValue,
                },
              },
            })
          }}
        />
      </HStack>
      <MatchEmailsExplainerModal
        isOpen={matchEmailsModelIsOpen}
        onClose={() => setMatchEmailsModalIsOpen(false)}
      />
    </Field.Root>
  )
}
